"use client";

import { useState } from "react";
import { useTranslations } from "next-intl";

import { Button } from "@/shared/ui/buttons/button";

/** С какого объёма текст сворачиваем: регламент турнира обычно длинный. */
const COLLAPSE_LIMIT = 1200;

/**
 * KAN-665: регламент турнира на вкладке «Обзор».
 *
 * Пустой регламент не рисует ничего — пустой карточки «Правила» быть не должно
 * (это уже чинил KAN-957). Длинный текст свёрнут, чтобы карточка не занимала
 * пол-страницы; абзацы сохраняются через whitespace-pre-wrap.
 */
export function TournamentRulesText({ text }: { text: string }) {
  const t = useTranslations("Tournaments");
  const [expanded, setExpanded] = useState(false);

  const normalized = text.trim();
  if (!normalized) return null;

  const isLong = normalized.length > COLLAPSE_LIMIT;
  const shown =
    isLong && !expanded
      ? `${normalized.slice(0, COLLAPSE_LIMIT).trimEnd()}…`
      : normalized;

  return (
    <div className="space-y-2">
      <div className="whitespace-pre-wrap break-words text-sm leading-relaxed text-foreground/90">
        {shown}
      </div>
      {isLong ? (
        <Button
          type="button"
          variant="link"
          size="sm"
          className="h-auto px-0 text-sm"
          onClick={() => setExpanded((value) => !value)}
        >
          {expanded
            ? t("overview.rulesShowLess")
            : t("overview.rulesShowMore")}
        </Button>
      ) : null}
    </div>
  );
}
